import { Locale } from 'modules/i18n';

export const notificationsMenuTranslation = {
  [Locale.en]: {
    title: 'Notifications',
    viewAll: 'View all notifications',
  },
};
